/**
 * Tracks which over-cap pets have already been "introduced" via the
 * one-time pulse on the locked Walk-now pill (and the locked Care-log
 * Upgrade button). We pulse ~5s (3 animation cycles) the first time
 * the family sees the locked state for a given pet, then never again
 * — quiet upgrade nudge, not a nag.
 *
 * Two independent buckets so a family upgrading from Free→Plus (which
 * unlocks the *second* pet's walk + care together) doesn't accidentally
 * re-pulse on a dog they already saw locked, and so each surface gets
 * its own one-shot intro per pet.
 */
const KEY_WALK = "famfeel:walk-upgrade-pulsed-pets";
const KEY_CARE = "famfeel:care-upgrade-pulsed-pets";

function readSet(key) {
  try {
    const raw = localStorage.getItem(key);
    if (!raw) return new Set();
    const arr = JSON.parse(raw);
    if (!Array.isArray(arr)) return new Set();
    return new Set(arr.filter((x) => typeof x === "string"));
  } catch {
    return new Set();
  }
}

function writeSet(key, s) {
  try {
    localStorage.setItem(key, JSON.stringify(Array.from(s)));
  } catch {
    /* private mode / quota — non-fatal */
  }
}

/** True when this pet still owes a one-time pulse on the locked Walk pill. */
export function shouldPulseWalkUpgrade(petId) {
  if (!petId) return false;
  return !readSet(KEY_WALK).has(petId);
}

/** Mark a pet as having been pulsed on the locked Walk pill. */
export function markWalkUpgradePulsed(petId) {
  if (!petId) return;
  const s = readSet(KEY_WALK);
  if (s.has(petId)) return;
  s.add(petId);
  writeSet(KEY_WALK, s);
}

/** True when this pet still owes a one-time pulse on the locked Care upgrade button. */
export function shouldPulseCareUpgrade(petId) {
  if (!petId) return false;
  return !readSet(KEY_CARE).has(petId);
}

/** Mark a pet as having been pulsed on the locked Care upgrade button. */
export function markCareUpgradePulsed(petId) {
  if (!petId) return;
  const s = readSet(KEY_CARE);
  if (s.has(petId)) return;
  s.add(petId);
  writeSet(KEY_CARE, s);
}
